import { useQuery } from '@tanstack/react-query'

import { getFreeeConnectionLinkedAccountForAccounting } from '@src/api'
import { DefaultApiGetFreeeConnectionLinkedAccountForAccountingRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchFreeeConnectionLinkedAccountForAccounting = (
  params: DefaultApiGetFreeeConnectionLinkedAccountForAccountingRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    queryFn: () =>
      getFreeeConnectionLinkedAccountForAccounting(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_FREEE_CONNECTION_LINKED_ACCOUNT_FOR_ACCOUNTING,
    ],
  })
}
